<template>
  <!-- 创建团成功弹窗+分享海报 -->
  <div class="Dialog create-clan" :class="{'create-clan-share':userAgent.msdk}" v-if="isShown">
    <div class="inner">
      <i class="close" @click="closeTeamCreate"></i>
      <div class="share_show-box" >
        <img class="share-bg" src="~2021team-pk-ui/assets/cjzd_fxbg.png" crossorigin alt="">
        <div class="title">{{ !userAgent.weixin ? "" : "小队" }}创建成功</div>
        <p class="description">邀请好友加入小队，消费期开始后，可根据小队点券总消费值解锁礼包哦～</p>
        <div class="con" id="share_box2" v-show="!dataURL">
          <img class="card-bg" :src="teamShareBg" alt="" />
          <div class="con-title">
            <img class="con-title-l" src="~2021team-pk-ui/assets/pop-title-icon-l.png" alt="">
            小队召集令
            <img class="con-title-r" src="~2021team-pk-ui/assets/pop-title-icon-r.png" alt="">
          </div>
<!--          <p class="con-txt">王者新春年货节组队开启！ 快来和我一起组队吧，一起开黑一起赢好礼～</p>-->
          <div class="con-code">
			<img class="code" id="share_qrcode" src="" alt="" />
		  </div>
           <div class="logo-con">
            <img class="logo" :src="teamShareLogo" alt="" />
		  </div>   
          <div class="con-clan">
            <img v-if="avatar" :src="avatar+((avatar.indexOf('?')>-1?'&':'?')+'t='+new Date().getTime())" crossorigin alt="" />
            <p v-if="nickname">{{ nickname ? (nickname + '的') : '' }}小队</p>
          </div>
          <img class="logo" style="width: 2.35rem;" src="~2021team-pk-ui/assets/logo02.png" crossorigin alt="">
        </div>
      </div>
      <div class="share_show" v-show="dataURL">
        <img :src="dataURL" style="width:4.94rem;" id="share_show2" alt="">
      </div>
      <div class="share_btn">
        <div class="po-share-box" v-if="userAgent.msdk">
          <div class="po-share">
            <a href="javascript:void 0;" @click="shareInGame('weixin','__mds_client_wx')" class="btn-qq">
              <img src="~2021team-pk-ui/assets/share2.png" alt="">
              <p class="share-p">微信</p>
            </a>
            <a href="javascript:void 0;" @click="shareInGame('pengy','__mds_client_timeline')" class="btn-kj">
              <img src="~2021team-pk-ui/assets/share1.png" alt="">
              <p class="share-p">朋友圈</p>
            </a>
            <a href="javascript:void 0;" @click="shareInGame('qq','__mds_client_qq')" class="btn-py">
              <img src="~2021team-pk-ui/assets/share3.png" alt="">
              <p class="share-p">QQ</p>
            </a>
            <a href="javascript:void 0;" @click="shareInGame('qzone','__mds_client_qzone')" class="btn-wx">
              <img src="~2021team-pk-ui/assets/share4.png" alt="">
              <p class="share-p">QQ空间</p>
            </a>
          </div>
        </div>
        <p class="share_btn_tip">长按保存邀请函</p>

      </div>
    </div>
  </div>

</template>

<script>
import { mapState, mapActions } from "vuex"
import html2canvas from "../../common/libs/html2canvas"
import QRCode from "qrcode"

export default {
  name: "TeamCreate",
  props: ["isShown", "teamShareBg", "teamShareLogo"],
  mounted() {
    this.setLoadingMsg("海报制作中，请稍等~")

    // if (this.userAgent.msdk) {
    //   QRCode.toDataURL(
    //     `${location.origin}${location.pathname}?${this.sandbox ? `sandbox=${this.sandbox}&` : ""}pf=__mds_activity.invatition#team/${
    //       this.currentTeamId
    //     }`,
    //     {
    //       margin: 1
    //     },
    //     function(err, url) {
    //       if (!err) {
    //         // 证明生成了二维码（canvas） 然后把二维码转为图片
    //         document.querySelector("#share_qrcode_ingame").src = url
    //       }
    //     }
    //   )
    //   this.generateScreenShots("share_box1", "share_show1")
    // } else {
    QRCode.toDataURL(
      `${this.gameInfo.SHARE_URL}${this.gameInfo.SHARE_URL.indexOf("?") > -1 ? "&" : "?"}${
        this.sandbox ? `sandbox=${this.sandbox}&` : ""
      }&offerId=${this.offerId}&pf=__mds_activity_invatition#team/${this.currentTeamId}`,
      {
        margin: 1
      },
      function(err, url) {
        if (!err) {
          // 证明生成了二维码（canvas） 然后把二维码转为图片
          document.querySelector("#share_qrcode").src = url
        }
      }
    )
    setTimeout(() => {
      this.generateScreenShots("share_box2", "share_show2")
    }, 1000)
    // }
    this.maskHeight = document.documentElement.scrollHeight
  },
  data() {
    return {
      dataURL: "",
      maskHeight: ""
    }
  },
  computed: {
    ...mapState(["userAgent", "nickname", "avatar", "sandbox", "currentTeamId", "offerId", "gameInfo"])
  },
  methods: {
    ...mapActions(["msdkShareTo", "setLoadingMsg"]),
    generateScreenShots(id) {
      let shareContent = document.querySelector("#" + id) //需要截图的包裹的（原生的）DOM 对象
      let width = shareContent.offsetWidth //获取dom 宽度
      let height = shareContent.offsetHeight //获取dom 高度
      // console.log(width,height)
      let canvas = document.createElement("canvas") //创建一个canvas节点
      let scale = 3 //定义任意放大倍数 支持小数
      canvas.width = width * scale //定义canvas 宽度 * 缩放
      canvas.height = height * scale //定义canvas高度 *缩放

      let content = canvas.getContext("2d") //获取context,设置scale
      content.scale(scale, scale)
      let rect = shareContent.getBoundingClientRect() //获取元素相对于视察的偏移量
      content.translate(-rect.left, -rect.top) //设置context位置，值为相对于视窗的偏移量负值，让图片复位
      let opts = {
        scale: scale, // 添加的scale 参数
        canvas: canvas, //自定义 canvas
        // logging: true, //日志开关，便于查看html2canvas的内部执行流程
        width: width, //dom 原始宽度
        height: height,
        backgroundColor: null,
        useCORS: true // 【重要】开启跨域配置
      }

      let self = this
      html2canvas(shareContent, opts)
        .then(function(canvas) {
          let context = canvas.getContext("2d")
          // 【重要】关闭抗锯齿
          context.mozImageSmoothingEnabled = false
          context.webkitImageSmoothingEnabled = false
          context.msImageSmoothingEnabled = false
          context.imageSmoothingEnabled = false
          // console.log(canvas.toDataURL("image/jpeg"))

          let base64 = canvas.toDataURL("image/png")
          self.dataURL = base64

          self.setLoadingMsg("")
          // document.querySelector("#" + imgid).src = base64 // 【重要】默认转化的格式为png,也可设置为其他格式
        })
        .catch(() => {
          self.setLoadingMsg("")
        })
    },
    closeTeamCreate() {
      this.$emit("update:isShown", false)
    },
    shareInGame(selected, pf) {
      this.msdkShareTo({
        selected,
        team_id: this.$route.params.team_id,
        pf
      })
    }
  }
}
</script>

<style scoped>
</style>
